"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[530],{

/***/ 9530:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "or": function() { return /* binding */ Main; },
  "Ai": function() { return /* binding */ MainSplit; },
  "Zy": function() { return /* binding */ MainStatic; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(5235);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(406);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(8526);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
;// CONCATENATED MODULE: ../../shared/frontend-resources/src/page/broadcastState.ts
var BROADCAST_STATE = 'travel_broadcast_state';

var getBroadcastState = function getBroadcastState() {
  try {
    return  true && JSON.parse(window.localStorage.getItem(BROADCAST_STATE)) || [];
  } catch (e) {
    return [];
  }
};

var filterDismissedBroadcasts = function filterDismissedBroadcasts(messages) {
  var dismissed = getBroadcastState().map(function (entry) {
    return entry.id;
  });
  return messages.filter(function (message) {
    return !dismissed.includes(message.id);
  });
};
var dismissBroadcast = function dismissBroadcast(broadcastId) {
  var currentState = getBroadcastState();
  currentState.push({
    id: broadcastId,
    timeout: Date.now() + 1209600000 // two weeks

  });
   true && window.localStorage.setItem(BROADCAST_STATE, JSON.stringify(currentState));
};
var purgeOutdatedBroadcasts = function purgeOutdatedBroadcasts() {
  return  true && window.localStorage.setItem(BROADCAST_STATE, JSON.stringify(getBroadcastState().filter(function (entry) {
    return entry.timeout > Date.now();
  })));
};
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2322);
;// CONCATENATED MODULE: ../../shared/frontend-resources/src/page/Broadcast.tsx







var messagesOrEmptyArray = function messagesOrEmptyArray(messages) {
  return Array.isArray(messages) ? messages : [];
};

var Broadcast = function Broadcast(props) {
  var _useState = (0,react.useState)(messagesOrEmptyArray(props.messages)),
      messages = _useState[0],
      setMessages = _useState[1];

  (0,react.useEffect)(function () {
    var fetchBroadcast = /*#__PURE__*/function () {
      var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
        var data, json;
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return fetch(props.url);

              case 3:
                data = _context.sent;
                _context.next = 6;
                return data.json();

              case 6:
                json = _context.sent;
                setMessages(messagesOrEmptyArray(json));
                _context.next = 13;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context["catch"](0);
                setMessages([]);

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 10]]);
      }));

      return function fetchBroadcast() {
        return _ref.apply(this, arguments);
      };
    }();

    if (props.url) {
      fetchBroadcast();
    }
  }, [props.url]);
  purgeOutdatedBroadcasts();

  var dismissMessage = function dismissMessage(id) {
    dismissBroadcast(id);
    setMessages(messages.filter(function (message) {
      return message.id !== id;
    }));
  };

  var renderTroika = function renderTroika(entry) {
    var _props$className, _entry$heading;

    return /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
      className: "broadcast ".concat((_props$className = props.className) !== null && _props$className !== void 0 ? _props$className : ''),
      role: "alert",
      "aria-atomic": "false",
      "data-testid": "Broadcast",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("button", {
        className: "button button--link button--small u-stone u-position-absolute u-top u-right u-pt8 u-pr8",
        "aria-label": "Skjul meldingen",
        onClick: function onClick() {
          return dismissMessage(entry.id);
        },
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 24 24",
          width: "14",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
            fill: "none",
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: "2.5",
            d: "M12 12l6 6-6-6-6 6 6-6zm0 0L6 6l6 6 6-6-6 6z"
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "broadcast__content",
        children: [(_entry$heading = entry.heading) !== null && _entry$heading !== void 0 && _entry$heading.trim() ? /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
          className: "u-t3",
          "data-testid": "Broadcast-messageTitle",
          children: entry.heading.trim()
        }) : null, /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          "data-testid": "Broadcast-messageText",
          dangerouslySetInnerHTML: {
            __html: entry.message
          }
        })]
      })]
    }, "broadcast".concat(entry.id));
  };

  var renderFabric = function renderFabric(entry) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
      className: "overflow-hidden w-full px-0 sm:px-16",
      "aria-label": "Varsel",
      "data-testid": "broadcast",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "toast flex group p-8 mt-16 rounded-8 border-2 w-full pointer-events-auto transition-all bg-yellow-50 border-yellow-200 text-yellow-800",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "flex-shrink-0 rounded-full w-16 h-16 m-8 bg-yellow-300",
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
            role: "img",
            "aria-label": "Varsel",
            xmlns: "http://www.w3.org/2000/svg",
            width: "16",
            height: "16",
            fill: "none",
            viewBox: "0 0 16 16",
            className: "transition-transform duration-200",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
              stroke: "currentColor",
              strokeLinecap: "round",
              strokeMiterlimit: "10",
              strokeWidth: "1.5",
              d: "M8 9V4"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("circle", {
              cx: "8",
              cy: "11.8",
              r: ".8",
              fill: "currentColor"
            })]
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          role: "alert",
          className: "self-center mr-8 py-4 last-child:mb-0",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            id: "toast-broadcast-toast-text",
            dangerouslySetInnerHTML: {
              __html: entry.message
            }
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
            className: "button button--pill text-gray-500",
            style: {
              minWidth: 32,
              minHeight: 32
            },
            "aria-label": "Skjul meldingen",
            onClick: function onClick() {
              return dismissMessage(entry.id);
            },
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
              xmlns: "http://www.w3.org/2000/svg",
              viewBox: "0 0 24 24",
              width: "14",
              height: "14",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
                fill: "none",
                stroke: "currentColor",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "2.5",
                d: "M12 12l6 6-6-6-6 6 6-6zm0 0L6 6l6 6 6-6-6 6z"
              })
            })
          })
        })]
      })
    }, "broadcast".concat(entry.id));
  };

  return filterDismissedBroadcasts(messages).filter(function (entry) {
    return !!entry.message;
  }).map(function (entry) {
    return props.troika ? renderTroika(entry) : renderFabric(entry);
  });
};
// EXTERNAL MODULE: ../../shared/frontend-resources/src/page/Header.tsx
var Header = __webpack_require__(8211);
;// CONCATENATED MODULE: ../../shared/frontend-resources/src/page/Footer.tsx
/* eslint-disable max-len */




var style = ":root{--schibsted-footer-color:#767676;--schibsted-footer-color-bg:#f8f6f5;--troika-footer-border-color:#ddd}.footer{border-top:1px solid #ddd;border-top:1px solid var(--troika-footer-border-color);padding:32px 0 0;color:#474445;color:var(--troika-licorice,#474445);font-size:14px;line-height:18px}.footer,.footer__pageholder{background-color:#fff;background-color:var(--troika-milk,#fff)}.footer__pageholder{padding:0;margin:0;max-width:1010px}.content-width--liquid .footer__pageholder,.footer__pageholder.content-width--liquid{max-width:none}.content-width--1400 .footer__pageholder,.footer__pageholder.content-width--1400{max-width:1400px}.content-width--1600 .footer__pageholder,.footer__pageholder.content-width--1600{max-width:1600px}@media (min-width:1300px){.footer__pageholder{margin-left:auto;margin-right:auto;padding:0 15px}}.footer-content{display:-ms-grid;display:grid;-ms-grid-columns:33.332% 1fr 1fr 1fr 1fr;grid-template-columns:33.332% 1fr 1fr 1fr 1fr;-ms-grid-rows:auto;grid-template-rows:auto;grid-template-areas:\"branding business about privacy support\" \"divider divider divider divider divider\" \"social copyrights copyrights copyrights copyrights\"}@media (max-width:989px){.footer-content{display:block;margin:0}}.footer-content nav h4:only-child{display:none}.footer-content a,.footer-content a:link,.footer-content a:visited{cursor:pointer;color:#0063fb;color:var(--troika-primary-blue,#0063fb);text-decoration:none}.footer-content a:active,.footer-content a:focus,.footer-content a:hover{color:#0063fb;color:var(--troika-primary-blue,#0063fb);text-decoration:underline;outline:none}.footer-content a,.footer-content a:active,.footer-content a:focus,.footer-content a:hover,.footer-content a:link,.footer-content a:visited{color:#474445;color:var(--troika-licorice,#474445)}.footer-content__branding{-ms-grid-row:1;-ms-grid-column:1;grid-area:branding;padding:16px}.footer-content__branding svg{margin-bottom:8px}@media (min-width:990px){.footer-content__branding svg{display:block}}.footer-content__branding a{font-size:22px!important;line-height:28px!important;font-weight:700;color:#474445;color:var(--troika-licorice,#474445)}@media (min-width:990px){.footer-content__branding a{display:block}}@media (max-width:989px){.footer-content__branding span{display:block}}.footer-content__business{-ms-grid-row:1;-ms-grid-column:2;grid-area:business}.footer-content__about{-ms-grid-row:1;-ms-grid-column:3;grid-area:about}.footer-content__privacy{-ms-grid-row:1;-ms-grid-column:4;grid-area:privacy;padding-bottom:41px}.footer-content__support{-ms-grid-row:1;-ms-grid-column:5;grid-area:support}.footer-content__divider{-ms-grid-row:2;-ms-grid-column:1;-ms-grid-column-span:5;grid-area:divider;padding:0;margin:32px 16px 0;border:0;border-top:1px solid #ddd;border-top:1px solid var(--troika-footer-border-color)}.footer-content__social{-ms-grid-row:3;-ms-grid-column:1;grid-area:social;padding-top:31px}.footer-content__social>a{display:inline-block;width:32px;height:32px;margin-right:29px;margin-top:-4px}.footer-content__social>a svg{width:26px;margin:3px}.footer-content__social__title{border:0;clip:rect(0 0 0 0);-webkit-clip-path:inset(50%);clip-path:inset(50%);height:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;width:1px;white-space:nowrap}@media (max-width:989px){.footer-content__social{text-align:center}}.footer-content__copyrights{-ms-grid-row:3;-ms-grid-column:2;-ms-grid-column-span:4;grid-area:copyrights;padding-top:31px;font-size:12px;line-height:16px;color:#767676;color:var(--troika-stone,#767676)}@media (max-width:989px){.footer-content__copyrights{text-align:center;max-width:692px;margin-left:auto;margin-right:auto;padding-left:16px;padding-right:16px}}@media (max-width:989px){.footer-content__about,.footer-content__branding,.footer-content__business,.footer-content__privacy,.footer-content__support{text-align:center;padding-bottom:32px}}.footer-content__about>a,.footer-content__branding>a,.footer-content__business>a,.footer-content__privacy>a,.footer-content__support>a{margin-bottom:8px}.footer-content__about,.footer-content__business,.footer-content__privacy,.footer-content__support{padding:16px;margin-bottom:16px}.footer-content__about a,.footer-content__business a,.footer-content__privacy a,.footer-content__support a{display:block}.footer-content__copyrights,.footer-content__social{padding-left:16px;padding-right:16px}.footer-content__title{font-size:16px;line-height:22px;font-weight:700;margin-bottom:8px}.footer-content__title a{font-size:14px;line-height:18px;margin-bottom:8px}.footer__schibsted-banner{color:#767676;color:var(--schibsted-footer-color);background-color:#f8f6f5;background-color:var(--schibsted-footer-color-bg);font-size:16px;line-height:22px;margin-top:16px;padding-top:24px;padding-bottom:24px}.footer__schibsted-banner__is-sticky{bottom:0;width:100%;border-top:1px solid #c3ccd9;position:fixed;z-index:2}.footer__schibsted-banner__pageholder{background-color:#fff;background-color:var(--troika-milk,#fff);padding:0;margin:0;max-width:1010px;background-color:#f8f6f5;background-color:var(--schibsted-footer-color-bg)}.content-width--liquid .footer__schibsted-banner__pageholder,.footer__schibsted-banner__pageholder.content-width--liquid{max-width:none}.content-width--1400 .footer__schibsted-banner__pageholder,.footer__schibsted-banner__pageholder.content-width--1400{max-width:1400px}.content-width--1600 .footer__schibsted-banner__pageholder,.footer__schibsted-banner__pageholder.content-width--1600{max-width:1600px}@media (min-width:1300px){.footer__schibsted-banner__pageholder{margin-left:auto;margin-right:auto;padding:0 15px}}.footer__schibsted-banner__pageholder__content{display:flex;align-items:center}.footer__schibsted-banner__pageholder__content a,.footer__schibsted-banner__pageholder__content a:link,.footer__schibsted-banner__pageholder__content a:visited{cursor:pointer;color:#0063fb;color:var(--troika-primary-blue,#0063fb);text-decoration:none}.footer__schibsted-banner__pageholder__content a:active,.footer__schibsted-banner__pageholder__content a:focus,.footer__schibsted-banner__pageholder__content a:hover{color:#0063fb;color:var(--troika-primary-blue,#0063fb);text-decoration:underline;outline:none;text-decoration:none}.footer__schibsted-banner__pageholder__content__logo{display:none}@media (min-width:768px){.footer__schibsted-banner__pageholder__content__logo{min-width:100px;min-height:22px;margin-right:16px;margin-left:16px;background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg viewBox='0 0 154 28' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%2331312F' fill-rule='evenodd'%3E%3Cpath d='M16.96 15c-.1-.21-.26-.52-.49-.81a.78.78 0 00-.61-.32c-.4 0-.67.29-.67.69 0 .14.04.26.1.38l.13.26c.02.04.02.08-.02.1-.04.02-.08 0-.1-.03l-.14-.23a.73.73 0 00-.61-.35.73.73 0 00-.65 1.06l.07.16c.02.04.02.09-.01.1-.04.03-.08 0-.1-.03a5.8 5.8 0 00-.12-.16.66.66 0 00-.54-.28c-.36 0-.66.27-.66.7 0 .12.06.28.12.42.29.65.43 1.29.43 2.27a4.1 4.1 0 01-4 4.19 4.3 4.3 0 01-4.17-2.9.15.15 0 00-.2-.1l-4.3 1.33a.15.15 0 00-.1.2 9.03 9.03 0 008.73 6.28A8.93 8.93 0 0016.95 15m-7.99-.6a.42.42 0 110-.84.42.42 0 010 .84m0-3.58a.42.42 0 110-.84.42.42 0 010 .84m0 1.78a.42.42 0 110-.83.42.42 0 010 .84m3.29 2.02a4.78 4.78 0 00-1.06-.7c-.17-.08-.25-.12-.46-.18-.16-.05-.31-.07-.46 0a.48.48 0 00-.27.58c.05.2.21.28.38.36a5.92 5.92 0 011.17.7c.22.15.5.18.7 0 .22-.2.22-.54 0-.76m1.5-1.05c-.28-.28-.6-.53-.9-.69a1.2 1.2 0 00-.32-.12.53.53 0 00-.53.17.51.51 0 00-.05.6c.1.15.22.23.36.34.22.15.37.27.57.44.14.12.25.24.43.26.23.03.47-.1.57-.3.12-.23.05-.51-.13-.7m-2.62-1.52c-.13-.05-.23-.1-.41-.14a.94.94 0 00-.43-.03.47.47 0 00-.29.72c.08.11.17.16.3.2l.32.12.28.1a.5.5 0 00.44-.14c.26-.25.17-.67-.21-.83m-.43-1.91a1.35 1.35 0 00-.25-.04c-.1-.01-.23 0-.32.07-.2.13-.26.4-.15.6.05.1.14.17.25.2.1.04.21.08.31.1.23.02.45-.13.5-.35.07-.26-.09-.5-.34-.58m2.23.75a1.98 1.98 0 00-.8-.29.53.53 0 00-.54.62c.03.16.14.3.28.37l.33.16c.12.06.24.14.37.17.16.05.34.01.47-.09.3-.24.24-.72-.1-.94m2.36 1.75a3.25 3.25 0 00-.79-.71.69.69 0 00-.5-.1.54.54 0 00-.4.32.54.54 0 00.12.56c.1.11.2.18.3.28.15.13.28.25.41.39.12.12.25.21.43.22.21 0 .42-.11.51-.3a.6.6 0 00-.07-.66'/%3E%3Cpath d='M.96 12.96c.1.22.25.53.48.82.15.19.37.32.62.32.4 0 .67-.3.67-.7a.84.84 0 00-.1-.38l-.13-.25c-.02-.04-.02-.09.01-.1.05-.03.09 0 .11.03l.14.23c.13.2.35.35.61.35a.73.73 0 00.65-1.07l-.08-.16c-.02-.04-.02-.08.02-.1.04-.03.08 0 .1.03l.12.17c.12.17.31.27.53.27.37 0 .67-.27.67-.69 0-.13-.06-.29-.12-.42a5.1 5.1 0 01-.44-2.28 4.1 4.1 0 014-4.18A4.3 4.3 0 0113 7.74c.03.08.11.12.19.1l4.3-1.33a.15.15 0 00.11-.19A9.03 9.03 0 008.87.04 8.93 8.93 0 00.96 12.96m8 4.19a.42.42 0 110 .83.42.42 0 010-.83m0-1.79a.42.42 0 110 .83.42.42 0 010-.83m-3.3-2.03a4.77 4.77 0 001.06.7c.18.08.26.13.47.19.16.04.31.06.45 0 .23-.1.35-.33.28-.59-.05-.2-.21-.28-.39-.36a5.94 5.94 0 01-1.16-.7c-.22-.15-.5-.17-.7 0-.22.2-.22.54 0 .76m-1.5 1.05c.28.29.6.54.9.7.1.05.18.08.32.11a.51.51 0 00.58-.76c-.1-.16-.22-.24-.37-.34a9.01 9.01 0 01-.57-.45c-.13-.11-.24-.23-.42-.26a.57.57 0 00-.58.3.63.63 0 00.14.7m2.62 1.52c.12.06.23.1.4.15.14.03.3.05.44.02a.47.47 0 00.28-.72c-.07-.1-.17-.15-.3-.2l-.3-.11-.3-.1a.5.5 0 00-.43.13c-.26.26-.18.67.2.84m.44 1.9l.24.05c.11 0 .23 0 .33-.08.2-.12.26-.39.15-.6a.46.46 0 00-.25-.2c-.1-.04-.21-.07-.31-.09a.47.47 0 00-.5.35c-.07.26.09.5.34.57m-2.23-.75a1.98 1.98 0 00.8.3c.32.01.6-.3.54-.62a.52.52 0 00-.28-.37l-.33-.17c-.12-.06-.24-.13-.38-.17a.54.54 0 00-.46.1c-.31.24-.25.71.1.93m-2.37-1.74a3.25 3.25 0 00.8.7c.14.1.32.15.5.11a.54.54 0 00.4-.33.54.54 0 00-.12-.56l-.3-.28a7.78 7.78 0 01-.42-.38c-.12-.12-.25-.22-.42-.22a.55.55 0 00-.52.3.6.6 0 00.08.66M49.5 9.61c-1.65 0-3.55.56-4.67 1.9V2.06a.15.15 0 00-.15-.15H40.3a.15.15 0 00-.15.15v25.16c0 .08.07.15.15.15h4.38c.08 0 .15-.07.15-.15V17.21c-.02-1.93 1.1-3.45 3.23-3.45 2.25 0 3.2 1.58 3.2 3.52v9.94c0 .08.07.15.15.15h4.38c.08 0 .15-.07.15-.15V16.47c0-3.8-2.04-6.86-6.44-6.86m12.8-8.12a2.9 2.9 0 00-2.9 2.92c0 1.54 1.3 2.85 2.89 2.85a2.86 2.86 0 002.86-3.22A2.92 2.92 0 0062.3 1.5m2.2 8.57h-4.38a.15.15 0 00-.15.15v17c0 .08.06.15.15.15h4.37c.09 0 .15-.07.15-.15v-17a.15.15 0 00-.15-.15m13.04 13.57c-2.35 0-4.36-1.83-4.36-4.96 0-3.16 2-4.92 4.36-4.92 2.4 0 4.3 1.76 4.3 4.92 0 3.17-1.9 4.96-4.3 4.96m.99-14.03c-2.57 0-4.47 1.13-5.24 2.36v-9.9a.15.15 0 00-.15-.16h-4.3a.15.15 0 00-.16.15v25.16c0 .08.07.15.15.15h4.24c.08 0 .15-.07.15-.15v-1.96c.91 1.48 2.74 2.53 5.13 2.53 4.92 0 8.16-3.9 8.16-9.14 0-5.13-2.92-9.04-7.98-9.04m35.98 13.76c-.3.05-.8.1-1.26.1-1.34 0-2.04-.5-2.04-2v-7.25h3.33c.09 0 .15-.07.15-.15v-3.85a.15.15 0 00-.15-.15h-3.33V5.05a.15.15 0 00-.15-.15h-4.32a.15.15 0 00-.15.15l-.01 5.02h-2.99a.15.15 0 00-.15.15v3.85c0 .08.07.15.15.15h2.98v8.05c0 3.34 2.11 5.35 5.49 5.35a7.2 7.2 0 002.53-.39c.06-.02.1-.08.1-.14v-3.58a.14.14 0 00-.17-.14m30.38.27c-2.47 0-4.3-1.86-4.3-4.96 0-3.09 1.9-4.88 4.3-4.88 2.39 0 4.3 1.75 4.3 4.85 0 3.13-1.91 5-4.3 5m8.68-21.74h-4.35a.15.15 0 00-.15.15v9.73c-.5-.91-1.9-2.14-4.89-2.14-4.89 0-8.3 3.97-8.3 9.03 0 5.24 3.52 9.11 8.44 9.11 2.32 0 4.08-1.05 4.86-2.42v1.85c0 .08.07.15.15.15h4.24c.09 0 .15-.07.15-.15V2.06a.15.15 0 00-.15-.15m-32.22 14.84a3.74 3.74 0 013.87-3.41c2.67 0 3.8 1.69 3.87 3.41h-7.74zm3.8-7.2c-4.43 0-8.51 3.58-8.51 9.1 0 5.84 4.18 9.25 8.93 9.25 3.54 0 6.04-1.73 7.28-4.04a.15.15 0 00-.07-.2l-3.5-1.53a.15.15 0 00-.2.06c-.66 1.03-1.77 1.7-3.47 1.7-2.32 0-4.26-1.65-4.36-3.94h12.23c.08 0 .15-.06.15-.14.02-.25.07-.78.07-1.3 0-5.56-3.2-8.97-8.55-8.97zM97.2 16.84l-2.46-.53c-.95-.17-1.58-.65-1.58-1.5 0-.98.99-1.72 2.22-1.72 1.68 0 2.47.96 2.74 1.87.03.09.12.13.2.1l3.48-1.35a.15.15 0 00.1-.2c-.62-1.8-2.45-3.97-6.56-3.97-3.73 0-6.47 2.57-6.47 5.66 0 2.43 1.51 4.5 4.85 5.24l2.29.53c1.34.28 1.86.84 1.86 1.62 0 .91-.73 1.72-2.28 1.72-1.96 0-2.98-1.17-3.15-2.48a.15.15 0 00-.18-.12l-3.71.81a.15.15 0 00-.12.17c.28 1.98 2.1 5.2 7.2 5.2 4.53 0 6.7-2.88 6.7-5.69 0-2.53-1.71-4.66-5.12-5.36M37.4 22.01l-3.84-1.27a.15.15 0 00-.19.1 3.95 3.95 0 01-3.93 2.77c-2.39 0-4.43-1.76-4.43-4.89s2-4.85 4.4-4.85c1.99 0 3.07 1.08 3.6 2.3.04.08.12.11.2.09l3.92-1.36a.15.15 0 00.1-.19c-.96-2.68-3.58-5.17-7.93-5.17-5.03 0-8.96 3.83-8.96 9.18 0 5.3 4 9.18 9.1 9.18 4.54 0 7.23-2.86 8.05-5.7a.15.15 0 00-.1-.19'/%3E%3C/g%3E%3C/svg%3E\");background-repeat:no-repeat;display:block}}.footer__schibsted-banner__pageholder__content__info-wide{flex-grow:1;display:none}@media (min-width:768px){.footer__schibsted-banner__pageholder__content__info-wide{display:block}}.footer__schibsted-banner__pageholder__content__info-narrow{flex-grow:1;font-size:12px;line-height:16px;margin-left:32px;margin-right:32px}@media (min-width:768px){.footer__schibsted-banner__pageholder__content__info-narrow{display:none}}";
var Footer = function Footer() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("style", {
      dangerouslySetInnerHTML: {
        __html: style
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("footer", {
      className: "footer noprint",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "footer__pageholder",
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "footer-content",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h1", {
            className: "footer-content__branding",
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
              href: "//www.finn.no/",
              "aria-label": "FINN.no",
              children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
                focusable: "false",
                width: "92",
                height: "32",
                viewBox: "0 0 184 64",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("title", {
                  children: "FINN.no"
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
                  fill: "#06bffc",
                  d: "M179.8 58V6c0-1-.8-1.9-1.9-1.9H66c-1 0-1.9.8-1.9 1.9v53.8H178c1 0 1.8-.8 1.8-1.8"
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
                  fill: "#0063fc",
                  d: "M22.5 4.2H6C5 4.2 4.2 5 4.2 6v52c0 1 .8 1.9 1.9 1.9H60V41.5C59.9 20.9 43.2 4.2 22.5 4.2"
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
                  fill: "#fff",
                  d: "M178 0H66c-3.3 0-6 2.7-6 6v17.4C53.2 9.6 38.9 0 22.5 0H6C2.7 0 0 2.7 0 6v52c0 3.3 2.7 6 6 6h172c3.3 0 6-2.7 6-6V6c0-3.3-2.7-6-6-6m1.8 58c0 1-.8 1.9-1.9 1.9H64.1V6c0-1 .8-1.9 1.9-1.9h112c1 0 1.9.8 1.9 1.9v52zM4.2 58V6C4.2 5 5 4.2 6 4.2h16.5c20.6 0 37.4 16.8 37.4 37.4v18.3H6c-1-.1-1.8-.9-1.8-1.9"
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
                  fill: "#fff",
                  d: "M110.1 21.1h-4.2c-.7 0-1.2.5-1.2 1.2v19.3c0 .7.5 1.2 1.2 1.2h4.2c.7 0 1.2-.5 1.2-1.2V22.3c0-.6-.6-1.2-1.2-1.2m-12 0H83c-.7 0-1.2.5-1.2 1.2v19.3c0 .7.5 1.2 1.2 1.2h4.2c.7 0 1.2-.5 1.2-1.2v-4h7.7c.7 0 1.2-.5 1.2-1.2v-3.2c0-.7-.5-1.2-1.2-1.2h-7.7v-4.9h9.7c.7 0 1.2-.5 1.2-1.2v-3.7c0-.5-.6-1.1-1.2-1.1m62.8 0h-4.2c-.7 0-1.2.5-1.2 1.2v9.5l-6.6-10c-.3-.4-.8-.7-1.3-.7h-3.2c-.7 0-1.2.5-1.2 1.2v19.3c0 .7.5 1.2 1.2 1.2h4.2c.7 0 1.2-.5 1.2-1.2v-9.4l6.5 9.8c.3.4.8.7 1.3.7h5.4c.7 0 1.2-.5 1.2-1.2V22.3c-.1-.6-.6-1.2-1.3-1.2m-25.4 0h-4.2c-.7 0-1.2.5-1.2 1.2v9.5l-6.6-10c-.3-.4-.8-.7-1.3-.7H119c-.7 0-1.2.5-1.2 1.2v19.3c0 .7.5 1.2 1.2 1.2h4.2c.7 0 1.2-.5 1.2-1.2v-9.4l6.5 9.8c.3.4.8.7 1.3.7h5.4c.7 0 1.2-.5 1.2-1.2V22.3c-.1-.6-.6-1.2-1.3-1.2"
                })]
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                children: "Mulighetenes marked"
              })]
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("nav", {
            className: "footer-content__business",
            "aria-label": "FINN Reise",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
              className: "footer-content__title",
              children: "FINN Reise"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              href: "https://www.finn.no/bedriftskunde/reise/dette-er-finn-reise-1",
              children: "Om FINN Reise"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              href: "https://www.finn.no/reise/norgesferie/",
              children: "FINN din Norgesferie"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              href: "https://www.finn.no/reise/valuta/",
              children: "Valutakalkulator"
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("nav", {
            className: "footer-content__about",
            "aria-label": "Partnere",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
              className: "footer-content__title",
              children: "Partnere"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              href: "https://hjelpesenter.finn.no/hc/no/sections/39344-V\xE5re-annonseregler",
              children: "Retningslinjer for partnere"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              href: "https://hjelpesenter.finn.no/hc/no/sections/39344-V\xE5re-annonseregler",
              children: "Feriehus retningslinjer"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              href: "https://hjelpesenter.finn.no/hc/no/articles/202416512-Policies-for-flight-suppliers-on-FINN-Travel-Prices",
              children: "Flypartnere"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              href: "https://www.finn.no/reise/hotell/hotelier",
              children: "Hotellinformasjon"
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("nav", {
            className: "footer-content__privacy",
            "aria-label": "FINN personvern",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
              className: "footer-content__title",
              children: "Personvern"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              href: "https://hjelpesenter.finn.no/hc/no/articles/305274",
              rel: "noopener nofollow noreferrer",
              children: "Personvernerkl\xE6ring"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              href: "https://www.finn.no/personvern",
              rel: "noopener nofollow noreferrer",
              children: "Innstillinger"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              href: "https://hjelpesenter.finn.no/hc/no/articles/211876885",
              rel: "noopener nofollow noreferrer",
              children: "Cookies"
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("nav", {
            className: "footer-content__support",
            "aria-label": "FINN hjelp",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
              className: "footer-content__title",
              children: "Om Finn"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              href: "https://hjelpesenter.finn.no/hc/no",
              className: "footer__link-list__help",
              rel: "noopener nofollow noreferrer",
              children: "Kundeservice"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              href: "https://www.finn.no/finnspirasjon",
              rel: "noopener nofollow noreferrer",
              children: "FINNspirasjon"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              href: "https://www.finn.no/jobbeifinn/vis/om-finn",
              rel: "noopener nofollow noreferrer",
              children: "Hvem er vi?"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              href: "https://www.finn.no/jobbeifinn",
              rel: "noopener nofollow noreferrer",
              children: "Jobbe i FINN"
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("hr", {
            className: "footer-content__divider",
            "aria-hidden": "true"
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("nav", {
            className: "footer-content__social",
            "aria-label": "FINN p\xE5 sosiale medier",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
              className: "u-screen-reader-only",
              children: "Sosiale medier"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              href: "https://www.facebook.com/finn.no/",
              title: "FINN p\xE5 Facebook",
              target: "_blank",
              rel: "noopener nofollow noreferrer",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                width: "32",
                height: "32",
                viewBox: "0 0 32 32",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
                  fill: "currentColor",
                  fillRule: "evenodd",
                  d: "M25.786 27H6.214C5.544 27 5 26.456 5 25.786V6.214C5 5.544 5.543 5 6.214 5h19.572C26.456 5 27 5.544 27 6.214v19.572c0 .67-.544 1.214-1.214 1.214zm-5.609-.002v-8.52h5.86l.428-3.32h-3.288v-2.12c0-.961.267-1.617 1.646-1.617h1.758V8.45a23.53 23.53 0 0 0-2.562-.13c-2.535 0-4.27 1.547-4.27 4.388v2.449h-2.867v3.32h5.867v8.52h5.428z"
                })
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              href: "https://twitter.com/finn_no",
              title: "FINN p\xE5 Twitter",
              target: "_blank",
              rel: "noopener nofollow noreferrer",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                width: "32",
                height: "32",
                viewBox: "0 0 32 32",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
                  fill: "currentColor",
                  fillRule: "evenodd",
                  d: "M12.225 25.818c8.679 0 13.428-7.242 13.428-13.511 0-.204 0-.408-.01-.612A9.648 9.648 0 0 0 28 9.232c-.847.38-1.758.63-2.715.75a4.773 4.773 0 0 0 2.08-2.63 9.353 9.353 0 0 1-3 1.148A4.697 4.697 0 0 0 20.922 7c-2.604 0-4.721 2.13-4.721 4.75 0 .371.046.732.12 1.084-3.921-.194-7.4-2.093-9.729-4.963a4.772 4.772 0 0 0-.635 2.389 4.77 4.77 0 0 0 2.099 3.954 4.751 4.751 0 0 1-2.136-.592v.064c0 2.297 1.63 4.223 3.783 4.659-.396.11-.81.166-1.242.166-.304 0-.599-.027-.884-.083a4.723 4.723 0 0 0 4.409 3.297 9.429 9.429 0 0 1-5.863 2.037c-.378 0-.755-.018-1.123-.065a13.364 13.364 0 0 0 7.225 2.121"
                })
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              href: "https://www.instagram.com/finn_no/",
              title: "FINN p\xE5 Instagram",
              target: "_blank",
              rel: "noopener nofollow noreferrer",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                width: "32",
                height: "32",
                viewBox: "0 0 32 32",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
                  fill: "currentColor",
                  fillRule: "evenodd",
                  d: "M16 5c-2.987 0-3.362.013-4.535.066-1.171.054-1.97.24-2.67.512a5.392 5.392 0 0 0-1.949 1.268 5.392 5.392 0 0 0-1.269 1.949c-.271.7-.457 1.499-.51 2.67C5.012 12.638 5 13.013 5 16s.013 3.362.066 4.535c.054 1.171.24 1.97.511 2.67a5.392 5.392 0 0 0 1.27 1.949 5.392 5.392 0 0 0 1.948 1.269c.7.271 1.499.457 2.67.51 1.173.054 1.548.067 4.535.067s3.362-.013 4.535-.066c1.171-.054 1.97-.24 2.67-.511a5.392 5.392 0 0 0 1.949-1.27 5.391 5.391 0 0 0 1.268-1.948c.272-.7.458-1.499.512-2.67.053-1.173.066-1.548.066-4.535s-.013-3.362-.066-4.535c-.054-1.171-.24-1.97-.512-2.67a5.392 5.392 0 0 0-1.268-1.949 5.391 5.391 0 0 0-1.949-1.268c-.7-.272-1.499-.458-2.67-.512C19.362 5.013 18.987 5 16 5m0 1.982c2.937 0 3.285.011 4.445.064 1.072.049 1.655.228 2.042.379.514.2.88.438 1.265.823.385.385.624.751.823 1.265.15.387.33.97.379 2.042.053 1.16.064 1.508.064 4.445 0 2.937-.011 3.285-.064 4.445-.05 1.072-.228 1.655-.379 2.042-.2.514-.438.88-.823 1.265a3.408 3.408 0 0 1-1.265.823c-.387.15-.97.33-2.042.379-1.16.053-1.508.064-4.445.064-2.937 0-3.285-.011-4.445-.064-1.072-.049-1.655-.228-2.043-.379-.513-.2-.88-.438-1.264-.823a3.409 3.409 0 0 1-.823-1.265c-.15-.387-.33-.97-.379-2.042-.053-1.16-.064-1.508-.064-4.445 0-2.937.011-3.285.064-4.445.049-1.072.228-1.655.379-2.042.2-.514.438-.88.823-1.265a3.408 3.408 0 0 1 1.264-.823c.388-.15.97-.33 2.043-.379 1.16-.053 1.508-.064 4.445-.064m0 12.685a3.667 3.667 0 1 1 0-7.334 3.667 3.667 0 0 1 0 7.334m0-9.316a5.649 5.649 0 1 1 0 11.298 5.649 5.649 0 0 1 0-11.298zm7.192-.223a1.32 1.32 0 1 1-2.64 0 1.32 1.32 0 0 1 2.64 0z"
                })
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              href: "https://www.youtube.com/user/finn",
              title: "FINN p\xE5 YouTube",
              target: "_blank",
              rel: "noopener nofollow noreferrer",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                width: "32",
                height: "32",
                viewBox: "0 0 32 32",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
                  fill: "currentColor",
                  fillRule: "evenodd",
                  d: "M15.749 8c-.994.003-4.796.031-7.451.23-.43.053-1.368.057-2.205.964-.66.69-.874 2.258-.874 2.258S5.017 13.14 5 14.898v2.198c.017 1.759.219 3.446.219 3.446s.214 1.568.874 2.258c.837.907 1.937.878 2.427.972 1.61.16 6.533.22 7.36.228h.41c1.059-.006 4.793-.04 7.411-.236.43-.053 1.368-.057 2.205-.964.66-.69.874-2.258.874-2.258S27 18.7 27 16.86v-1.726c0-1.842-.22-3.682-.22-3.682s-.214-1.568-.874-2.258c-.837-.907-1.775-.911-2.205-.964-2.656-.199-6.457-.227-7.452-.23h-.5zm-2.022 4.56l5.945 3.208-5.944 3.187-.001-6.395z"
                })
              })
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "footer-content__copyrights",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
              children: "Innholdet er beskyttet etter \xE5ndsverkloven. Regelmessig, systematisk eller kontinuerlig innhenting, lagring, indeksering, distribusjon og all annen form for sammenstilling av data tillates ikke uten eksplisitt, skriftlig tillatelse fra FINN.no."
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
              children: ["\xA9 1996\u2013", new Date().getFullYear(), " FINN.no AS"]
            })]
          })]
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        id: "schibsted-banner",
        className: "footer__schibsted-banner",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "footer__schibsted-banner__pageholder",
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "footer__schibsted-banner__pageholder__content",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "footer__schibsted-banner__pageholder__content__logo"
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "footer__schibsted-banner__pageholder__content__info-wide",
              children: ["FINN.no er en del av Schibsted. Schibsted er ansvarlig for dine data p\xE5 denne siden.", ' ', /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                href: "https://info.privacy.schibsted.com/no/schibsted-norge-personvernerklaering/",
                target: "_blank",
                rel: "noopener nofollow noreferrer",
                children: "Les mer"
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "footer__schibsted-banner__pageholder__content__info-narrow",
              children: ["Schibsted er ansvarlig for dine data p\xE5 denne siden.", ' ', /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                href: "https://info.privacy.schibsted.com/no/schibsted-norge-personvernerklaering/",
                target: "_blank",
                rel: "noopener nofollow noreferrer",
                children: "Les mer"
              })]
            })]
          })
        })
      })]
    })]
  });
};
;// CONCATENATED MODULE: ../../shared/frontend-resources/src/page/Main.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }









var Main = function Main(_ref) {
  var _podlets$horseshoe, _podlets$js;

  var podlets = _ref.podlets,
      broadcastUrl = _ref.broadcastUrl,
      troika = _ref.troika,
      className = _ref.className,
      children = _ref.children;

  var renderMain = function renderMain() {
    return /*#__PURE__*/(0,jsx_runtime.jsxs)("main", {
      className: "".concat(troika ? 'pageholder' : 'page-container', " ").concat(className !== null && className !== void 0 ? className : ''),
      children: [broadcastUrl && /*#__PURE__*/(0,jsx_runtime.jsx)(Broadcast, {
        url: broadcastUrl,
        troika: troika
      }), children]
    });
  };

  return podlets ? /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [podlets.header ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", _objectSpread({
      suppressHydrationWarning: true
    }, podlets.header.props)) : /*#__PURE__*/(0,jsx_runtime.jsx)(Header/* Header */.h, {}), /*#__PURE__*/(0,jsx_runtime.jsx)("div", _objectSpread({
      suppressHydrationWarning: true
    }, (_podlets$horseshoe = podlets.horseshoe) === null || _podlets$horseshoe === void 0 ? void 0 : _podlets$horseshoe.props)), renderMain(), podlets.footer ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", _objectSpread({
      suppressHydrationWarning: true
    }, podlets.footer.props)) : /*#__PURE__*/(0,jsx_runtime.jsx)(Footer, {}), (_podlets$js = podlets.js) === null || _podlets$js === void 0 ? void 0 : _podlets$js.map(function (script) {
      return /*#__PURE__*/(0,react.createElement)("script", _objectSpread(_objectSpread({}, script.props), {}, {
        key: script.key
      }));
    })]
  }) : renderMain();
};
var MainStatic = function MainStatic(_ref2) {
  var troika = _ref2.troika,
      className = _ref2.className,
      children = _ref2.children;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Header/* Header */.h, {}), /*#__PURE__*/(0,jsx_runtime.jsx)("main", {
      className: "".concat(troika ? 'pageholder' : 'page-container', " ").concat(className !== null && className !== void 0 ? className : ''),
      children: children
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Footer, {})]
  });
}; // Two 'page-container' areas with different background colors, common for admin pages. Fabric only.

var MainSplit = function MainSplit(_ref3) {
  var _podlets$horseshoe2, _podlets$js2;

  var top = _ref3.top,
      podlets = _ref3.podlets,
      broadcastUrl = _ref3.broadcastUrl,
      className = _ref3.className,
      children = _ref3.children;

  var renderMain = function renderMain() {
    return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
        className: "page-container ".concat(className !== null && className !== void 0 ? className : ''),
        children: [broadcastUrl && /*#__PURE__*/(0,jsx_runtime.jsx)(Broadcast, {
          url: broadcastUrl
        }), top]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("main", {
        className: "bg-bluegray-50",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "page-container bg-bluegray-50 ".concat(className !== null && className !== void 0 ? className : ''),
          children: children
        })
      })]
    });
  };

  return podlets ? /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [podlets.header ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", _objectSpread({}, podlets.header.props)) : /*#__PURE__*/(0,jsx_runtime.jsx)(Header/* Header */.h, {}), /*#__PURE__*/(0,jsx_runtime.jsx)("div", _objectSpread({}, (_podlets$horseshoe2 = podlets.horseshoe) === null || _podlets$horseshoe2 === void 0 ? void 0 : _podlets$horseshoe2.props)), renderMain(), podlets.footer ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", _objectSpread({}, podlets.footer.props)) : /*#__PURE__*/(0,jsx_runtime.jsx)(Footer, {}), (_podlets$js2 = podlets.js) === null || _podlets$js2 === void 0 ? void 0 : _podlets$js2.map(function (script) {
      return /*#__PURE__*/(0,react.createElement)("script", _objectSpread(_objectSpread({}, script.props), {}, {
        key: script.key
      }));
    })]
  }) : renderMain();
};

/***/ })

}]);